"use strict";
var qs = require('qs');
var rawJsonp = require('jsonp');
function jsonp(url, body) {
    return new Promise(function (resolve, reject) {
        rawJsonp(url + "?" + qs.stringify(body), function (err, data) { return err ? reject(err) : resolve(data); });
    });
}
exports.jsonp = jsonp;



//////////////////
// WEBPACK FOOTER
// ./~/sayt/dist/src/core/utils.js
// module id = 209
// module chunks = 0